import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { ASSETS } from "@/lib/assets";

const ease = [0.76, 0, 0.24, 1];

export const Preloader = ({ onDone }) => {
    const [progress, setProgress] = useState(0);
    const [gone, setGone] = useState(false);

    useEffect(() => {
        let raf;
        const start = performance.now();
        const total = 1400;
        const tick = (t) => {
            const p = Math.min(1, (t - start) / total);
            setProgress(Math.floor(p * 100));
            if (p < 1) raf = requestAnimationFrame(tick);
            else {
                setTimeout(() => {
                    setGone(true);
                    onDone && onDone();
                }, 350);
            }
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [onDone]);

    return (
        <AnimatePresence>
            {!gone && (
                <motion.div
                    initial={{ y: 0 }}
                    exit={{ y: "-100%" }}
                    transition={{ duration: 1.1, ease }}
                    className="fixed inset-0 z-[100] bg-surya-bg text-surya-ink flex flex-col items-center justify-center overflow-hidden"
                    data-testid="preloader"
                >
                    <motion.img
                        src={ASSETS.logo}
                        alt="Surya"
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.9, ease }}
                        className="h-24 w-24 md:h-32 md:w-32 object-contain mb-8"
                    />
                    <div className="font-serif text-2xl md:text-3xl font-light tracking-tight">
                        Surya{" "}
                        <span className="italic-display text-surya-orange">Dental.</span>
                    </div>
                    <div className="mt-10 h-px w-56 bg-surya-line relative overflow-hidden">
                        <motion.div
                            className="absolute inset-y-0 left-0 bg-surya-orange"
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                    <div className="label text-surya-muted mt-4">
                        {String(progress).padStart(3, "0")} — loading
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
